import connection from "../../utils/connection";

const validarToken = async () => {
    let response = {};
    try {
        const responseGet = await connection({
            url: `/usuarios/auth/validar-token`,
        });
        response.data = responseGet;
    } catch (error) {
        console.error("catch service", error);
        response = error.response;
    }

    return response;
};

export default validarToken;
